import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export interface HeroSettings {
  id: string;
  mode: "image" | "video";
  image_url: string | null;
  youtube_video_id: string | null;
  cover_image_url: string | null;
  alt_text: string | null;
  updated_at: string;
}

export const HERO_SETTINGS_ID = "00000000-0000-0000-0000-000000000001";

export const useHeroSettings = () => {
  const [settings, setSettings] = useState<HeroSettings | null>(null);
  const [loading, setLoading] = useState(true);

  const fetchSettings = async () => {
    const { data } = await supabase
      .from("hero_settings" as any)
      .select("*")
      .eq("id", HERO_SETTINGS_ID)
      .maybeSingle();
    if (data) setSettings(data as unknown as HeroSettings);
    setLoading(false);
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return { settings, loading, refetch: fetchSettings };
};
